<template>
  <crud-form
    v-model="payload"
    page-title="Adicionar administrador"
    :request-class="requestClass"
    :total-group="3"
    navigate-back-route="administrator.list"
    navigate-page-after-save="administrator.list"
    :override-create-payload="overrideCreatePayload"
    :override-edit-payload="overrideEditPayload"
    :override-set-entity-data="overrideSetEntityData"
  >
    <template slot="group-1">
      <form-group title="Dados gerais">
        <v-row>
          <v-col cols="12">
            <input-text
              v-model="payload.name"
              :rules="[requiredRule]"
              label="Nome"
              outlined
              required
            />
          </v-col>
        </v-row>
        <v-row class="justify-end">
          <v-col cols="6">
            <input-text
              v-model="payload.cpf"
              v-mask="'###.###.###-##'"
              :rules="[requiredRule, minLength(14)]"
              label="CPF"
              outlined
              required
            />
          </v-col>
        </v-row>
        <v-row class="justify-end">
          <v-col cols="6">
            <input-text
              v-model="payload.email"
              :rules="[requiredRule]"
              label="E-mail"
              outlined
              required
            />
          </v-col>
        </v-row>
      </form-group>
    </template>
    <template slot="group-2">
      <v-divider class="mx-8" />
    </template>
    <template slot="group-3">
      <form-group title="Dados do sistema">
        <v-row class="justify-end">
          <v-col cols="6">
            <v-select
              id="input:Saque"
              v-model="payload.hasAccessToCashOut"
              :rules="[requiredRule]"
              :items="hasAccessToCashOutOptions"
              item-text="text"
              item-value="value"
              label="Saque"
              outlined
              required
            />
          </v-col>
        </v-row>
      </form-group>
    </template>
  </crud-form>
</template>

<script>
import CrudForm from 'Arch/components/crud/CrudForm.vue';
import AdministratorsRequest from 'App/administrators/AdministratorsRequest';
import FormGroup from 'Arch/components/crud/components/FormGroup.vue';
import RulesMixin from 'Arch/mixins/RulesMixin';
import CpfFilter from 'Arch/filters/CpfFilter';

export default {
  name: 'AdministratorsForm',
  filters: { CpfFilter },
  components: {
    CrudForm,
    FormGroup,
  },
  mixins: [RulesMixin],
  data: () => ({
    requestClass: AdministratorsRequest,
    payload: {
      id: null,
      name: '',
      hasAccessToCashOut: '',
      cpf: '',
      email: '',
    },
    hasAccessToCashOutOptions: [
      { value: true, text: 'Verdadeiro' },
      { value: false, text: 'Falso' },
    ],
  }),
  methods: {
    overrideSetEntityData(data) {
      return {
        id: data.id,
        cpf: CpfFilter(data.cpf),
        hasAccessToCashOut: data.hasAccessToCashOut,
        email: data.email,
        name: data.name,
      };
    },
    overrideCreatePayload() {
      return {
        id: this.payload.id,
        cpf: this.payload.cpf.replace(/[^0-9]/g, ''),
        hasAccessToCashOut: this.payload.hasAccessToCashOut,
        email: this.payload.email,
        name: this.payload.name,
      };
    },
    overrideEditPayload() {
      return {
        id: this.payload.id,
        cpf: this.payload.cpf.replace(/[^0-9]/g, ''),
        hasAccessToCashOut: this.payload.hasAccessToCashOut,
        email: this.payload.email,
        name: this.payload.name,
      };
    },

  },
};
</script>
